import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const immich = defineConnector({
  identifier: "immich",
  name: "Immich",
  tagLine: "Self-hosted photo and video management",
  logo,
  protocol: "http",
  tags: ["data"],
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Immich, go to **Account Settings → API Keys** and create a new key.",
        },
      ],
    },
    {
      title: "Enter your Immich details",
      items: [
        {
          kind: "baseUrl",
          label: "Immich server URL",
          required: true,
          placeholder: "https://immich.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Immich server.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/server/about`,
  },
});
